import { render, staticRenderFns } from "./WelcomeReferral.vue?vue&type=template&id=a69c51de"
import script from "./WelcomeReferral.vue?vue&type=script&lang=js"
export * from "./WelcomeReferral.vue?vue&type=script&lang=js"
import style0 from "./WelcomeReferral.vue?vue&type=style&index=0&id=a69c51de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports